import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-183143a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalBackdrop flex absolute z-max" }
const _hoisted_2 = { class: "c4c-modal" }
const _hoisted_3 = { class: "panelheader" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headerTitle" }, "Workforce Request Status", -1))
const _hoisted_5 = { "aria-hidden": "true" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text" }, "Close", -1))
const _hoisted_7 = {
  id: "workforceRequestModal",
  class: "panleBody scrollBar border"
}
const _hoisted_8 = {
  class: "tab-content",
  id: "workforceRequestModalTabContent"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_StatusTab = _resolveComponent("StatusTab")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("a", {
          href: "#",
          class: "closeBtn neu-tooltip",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, [
          _createElementVNode("i", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'close'],
              size: "lg"
            })
          ]),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_StatusTab, { statusInput: _ctx.workforceRequestInput }, null, 8, ["statusInput"])
        ])
      ])
    ])
  ]))
}